import { useLoadPipeline } from '../pipeline/useLoadPipeline';
import { createContext, useContext, useRef } from 'react';
import { useLoadRecordCardProperties } from '../properties/hooks/useLoadRecordCardProperties';
import { jsx as _jsx } from "react/jsx-runtime";
const PipelinePreloadContext = /*#__PURE__*/createContext({
  loading: true
});
export const PipelinePreloadProvider = ({
  children,
  pipelineId
}) => {
  const {
    data: pipeline,
    loading: pipelineLoading
  } = useLoadPipeline(pipelineId);
  const {
    data: cardProperties,
    loading: recordCardPropsLoading
  } = useLoadRecordCardProperties({
    pipelineId
  });
  const store = useRef({
    loading: true
  });
  if (pipeline && !pipelineLoading && cardProperties && !recordCardPropsLoading) {
    store.current = {
      pipeline,
      cardProperties
    };
  }
  return /*#__PURE__*/_jsx(PipelinePreloadContext.Provider, {
    value: store.current,
    children: children
  });
};
export const usePipelinePreload = () => {
  const store = useContext(PipelinePreloadContext);
  if ('loading' in store) {
    throw new Error('PipelinePreloadProvider is not loaded');
  }
  return store;
};
export const usePipelinePreloadLoading = () => {
  const store = useContext(PipelinePreloadContext);
  return 'loading' in store;
};